import notaApi from '../config/notaApi';

const studyAbroadService = {
  // Get student profile
  getProfile: async () => {
    const response = await notaApi.get('/api/nota/study-abroad/profile');
    return response.data;
  },

  // Get dashboard overview
  getOverview: async () => {
    const response = await notaApi.get('/api/nota/study-abroad/overview');
    return response.data;
  },

  // Update personal details
  updatePersonalDetails: async (data) => {
    const response = await notaApi.put('/api/nota/study-abroad/personal-details', data);
    return response.data;
  },

  // Update academic history
  updateAcademicHistory: async (data) => {
    const response = await notaApi.put('/api/nota/study-abroad/academic-history', data);
    return response.data;
  },

  // Update programme preferences
  updateProgrammePreferences: async (data) => {
    const response = await notaApi.put('/api/nota/study-abroad/programme-preferences', data);
    return response.data;
  },

  // Upload document
  uploadDocument: async (data) => {
    const response = await notaApi.post('/api/nota/study-abroad/documents', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get all documents
  getDocuments: async () => {
    const response = await notaApi.get('/api/nota/study-abroad/documents');
    return response.data;
  },

  // Delete document
  deleteDocument: async (documentId) => {
    const response = await notaApi.delete(`/api/nota/study-abroad/documents/${documentId}`);
    return response.data;
  },

  // Get SOP profile
  getSOPProfile: async () => {
    const response = await notaApi.get('/api/nota/study-abroad/sop');
    return response.data;
  },

  // Update SOP section
  updateSOPSection: async (section, data) => {
    const response = await notaApi.put(`/api/nota/study-abroad/sop/${section}`, data);
    return response.data;
  },

  // Submit SOP
  submitSOP: async () => {
    const response = await notaApi.post('/api/nota/study-abroad/sop/submit');
    return response.data;
  },

  // Upload SOP document
  uploadSOP: async (data) => {
    const response = await notaApi.post('/api/nota/study-abroad/sop/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Record payment
  recordPayment: async (data) => {
    const response = await notaApi.post('/api/nota/study-abroad/payment', data);
    return response.data;
  },

  // Payment methods
  createPaymentRequest: async () => {
    const response = await notaApi.post('/api/nota/study-abroad/payment/request');
    return response.data;
  },

  automatePayment: async (requestId) => {
    const response = await notaApi.post('/api/nota/study-abroad/payment/automate', { requestId });
    return response.data;
  },

  getPaymentStatus: async (requestId) => {
    const response = await notaApi.get(`/api/nota/study-abroad/payment/status/${requestId}`);
    return response.data;
  },

  getPaymentRequests: async (params) => {
    const response = await notaApi.get('/api/nota/study-abroad/payment/requests', { params });
    return response.data;
  },

  // Change password
  changePassword: async (data) => {
    const response = await notaApi.put('/api/nota/study-abroad/change-password', data);
    return response.data;
  }
};

export default studyAbroadService;
